import PropTypes from 'prop-types';

export const DescriptionField = ({ itemFormData, setItemFormData }) => {

  const handleChange = (e) => {
    setItemFormData({
      ...itemFormData,
      description: e.target.value
    });
  };

  return (
    <div>
      <form>
        <div>
          <label>Description:</label>
          <input
            type="text"
            name="description"
            value={itemFormData.description}
            onChange={handleChange}
            placeholder="Enter Item description"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}
          />
        </div>
      </form>
    </div>
  );
};

DescriptionField.propTypes = {
  itemFormData: PropTypes.object.isRequired,
  setItemFormData: PropTypes.func.isRequired,
};

export default DescriptionField;
